export default class Footer {
  constructor() {
    const emailButton = document.getElementById('email')
    const accordionElement = document.querySelector('.block-accordion')
    const toogleItem = document.querySelector('.toogle-item')

    toogleItem.addEventListener('click', function (event) {
      if (event.target !== 'a') {
        toogleItem.classList.toggle('active')
      }
    })

    if (emailButton) {
      emailButton.addEventListener('click', function () {
        if (accordionElement.classList.contains('active')) {
          return
        } else {
          accordionElement.classList.add('active')
        }
      })
    }

    const checkboxes = document.querySelectorAll('.chk_cmp113')
    const labels = document.querySelectorAll('.checkboxLabel')

    function updateLabelStyle() {
      checkboxes.forEach((checkbox, index) => {
        const label = labels[index]
        if (checkbox.checked) {
          label.classList.add('bold')
        } else {
          label.classList.remove('bold')
        }
      })
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', updateLabelStyle)
    })

    updateLabelStyle()

    window.onbeforeunload = function () {
      console.log('Tchau')
      document.body.classList.add('tchau')
    }
  }
}
